import React from 'react';
import { Link } from 'react-router-dom';

const ContactUs = () => (
  <div className="flex justify-center px-2 md:px-6 lg:px-0">
    <div className="w-full max-w-3xl md:px-10 px-2 py-8 bg-white rounded-lg shadow-lg mt-8 mb-8">
      <h1 className="text-3xl font-bold mb-6 text-center">Contact Us</h1>
      <div className="space-y-6 text-gray-700">
        <p className="text-center text-lg mb-8">
          We're here to help! Contact us by email at{' '}
          <a href="mailto:info@netpoints.net" className="text-blue-600 underline hover:text-blue-800">
            info@netpoints.net
          </a>
        </p>
        
        <div className="space-y-6">
          <div className="border-l-4 border-blue-600 pl-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900">General Enquiries</h2>
            <p className="text-gray-600">
              Have a question about our services, features, or how NetPoints works? We're happy to answer any general questions you may have.
            </p>
          </div>

          <div className="border-l-4 border-green-600 pl-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900">Affiliate Partnership</h2>
            <p className="text-gray-600">
              Interested in becoming an affiliate partner? Learn more about our partnership opportunities and how you can benefit from working with NetPoints.
            </p>
          </div>

          <div className="border-l-4 border-orange-600 pl-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900">Technical Support</h2>
            <p className="text-gray-600">
              Experiencing technical issues or need help with your account? Our support team is ready to assist you with any technical problems you may encounter.
            </p>
          </div>

          <div className="border-l-4 border-purple-600 pl-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900">Score or Points Query</h2>
            <p className="text-gray-600">
              Have questions about your points balance or need to query a score? We can help clarify any discrepancies or answer questions about your account activity.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-center text-gray-600">
            Please include relevant details in your email to help us assist you more efficiently. We aim to respond to all enquiries within 24-48 hours.
          </p>
        </div>

        <div className="flex justify-center mt-8">
          <Link to="/dashboard" className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 transition-colors">
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default ContactUs; 